import * as React from 'react';
import cn from 'classnames';
import * as Styles from '@components/atoms/Icon/Icon.module.scss';
import type { IconProps } from '@components/atoms/Icon/icon-prop-types';
import { IconSizes } from '@components/atoms/Icon/icon-prop-types';

export const GoingIcon = ({ fill = 'gcGreen', stroke = 'white', size = 'xsmall' }: IconProps) => {
    const fillStyles = cn(Styles[fill], Styles.fill);
    const strokeStyles = cn(Styles[stroke], Styles.stroke);
    const checkFillStyles = cn(Styles[stroke], Styles.fill);

    return (
        <svg
            xmlnsXlink="http://www.w3.org/1999/xlink"
            width={IconSizes[size]}
            height={IconSizes[size]}
            viewBox={`0 0 15 15`}
            role="img"
        >
            <title>Responded Going</title>
            <g fill="none" fillRule="evenodd">
                <circle className={fillStyles} cx={7} cy={7} r={6} />
                <circle className={strokeStyles} cx={7} cy={7} r={6.5} />
                <path
                    d="M5.499 10.365L3.1 8.04a.598.598 0 0 1 0-.863.643.643 0 0 1 .89 0l1.508 1.463 4.51-4.377a.642.642 0 0 1 .89 0 .597.597 0 0 1 0 .864l-5.4 5.24z"
                    className={checkFillStyles}
                />
            </g>
        </svg>
    );
};
